<template>
  <v-card
    elevation="4"
    class="data-table"
    :class="canBeSelected ? 'data-table--selectable' : ''"
  >
    <v-data-table
      calculate-widths
      :headers="headers"
      :items="itemsLoading ? [] : items"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :search="searchTerm"
      :sort-by="sortBy.value"
      :sort-desc="sortDesc"
      hide-default-footer
      hide-default-header
      class="elevation-0 custom-data-table"
      :server-items-length="itemsTotal"
    >
      <template v-if="itemsLoading" v-slot:body>
        <theme-table-sort-skeleton />
        <theme-table-skeleton-item />
      </template>

      <template v-slot:no-data>
        <data-iterator-no-results-container
          v-if="searchTerm"
          @clearAllFilters="$emit('clearAllFilters')"
          :searchTerm="searchTerm"
        />
        <template v-else>
          <div
            class="d-flex flex-column align-center justify-center mx-auto my-10"
            style="max-width: 560px"
          >
            <div
              class="flex justify-center"
              style="max-width: 64px; margin: auto"
            >
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_7045_265623)">
                  <g clip-path="url(#clip1_7045_265623)">
                    <path
                      d="M22.13 2.73981C31.62 -6.65019 60.16 9.38981 63.12 30.8798C66.45 55.0098 44.27 42.6498 34.74 58.6198C21.48 80.8198 -5.83 30.5198 2.58 22.1698C7.51 17.2598 13.1 25.8998 19.17 19.8698C25.24 13.8398 17.74 7.14981 22.16 2.74981H22.14L22.13 2.73981Z"
                      fill="#F9F9FB"
                    />
                  </g>
                  <path
                    d="M10.76 12.6599H52.57C53.93 12.6599 55.01 13.8999 55.01 15.3899V23.6299H8V15.7199C8 14.0299 9.24 12.6299 10.76 12.6299V12.6599Z"
                    fill="#EEEEF4"
                  />
                  <path
                    d="M52.24 52.6401H10.44C9.08 52.6401 8 51.5801 8 50.3001V23.6401H55V49.9901C55 51.4401 53.76 52.6401 52.24 52.6401Z"
                    fill="white"
                  />
                  <path
                    d="M53.58 12.6399H10.42C9.08 12.6399 8 13.7199 8 15.0499V50.2399C8 51.5699 9.08 52.6499 10.42 52.6499H53.58C54.92 52.6499 56 51.5699 56 50.2399V15.0399C56 13.7099 54.92 12.6299 53.58 12.6299V12.6399Z"
                    stroke="#B0B0D3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 24.6401H55"
                    stroke="#B0B0D3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M50.24 45.8799V42.4599C50.24 41.4381 49.4117 40.6099 48.39 40.6099H30.86C29.8383 40.6099 29.01 41.4381 29.01 42.4599V45.8799C29.01 46.9016 29.8383 47.7299 30.86 47.7299H48.39C49.4117 47.7299 50.24 46.9016 50.24 45.8799Z"
                    stroke="#B0B0D3"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M50.25 34.5V31.08C50.25 30.0583 49.4217 29.23 48.4 29.23H30.87C29.8483 29.23 29.02 30.0583 29.02 31.08V34.5C29.02 35.5217 29.8483 36.35 30.87 36.35H48.4C49.4217 36.35 50.25 35.5217 50.25 34.5Z"
                    stroke="#B0B0D3"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M45.96 38.6202L43.38 37.4902L54.46 11.3502C55 10.0302 56.36 9.33022 57.46 9.81022C58.56 10.2902 58.96 11.7602 58.35 13.0602L45.95 38.6202H45.96Z"
                    fill="#EEEEF4"
                    stroke="#797997"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M38.91 40.8001C37.71 44.0601 36.78 44.1901 35.91 44.8801C35.22 45.4401 39.26 46.8701 42.88 45.6901C45.92 44.7001 48.22 39.6801 44.89 38.1001C40.8 36.1601 39.21 39.9901 38.92 40.8001H38.91Z"
                    fill="#EEEEF4"
                    stroke="#797997"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M46.52 30.4404L49.36 31.6504"
                    stroke="#797997"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M22.26 29.21H15.49C14.4683 29.21 13.64 30.0382 13.64 31.06V45.87C13.64 46.8917 14.4683 47.72 15.49 47.72H22.26C23.2817 47.72 24.11 46.8917 24.11 45.87V31.06C24.11 30.0382 23.2817 29.21 22.26 29.21Z"
                    stroke="#B0B0D3"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M16.53 8.06C17.93 8.06 19.06 6.93 19.06 5.53C19.06 4.13 17.93 3 16.53 3C15.13 3 14 4.13 14 5.53C14 6.93 15.13 8.06 16.53 8.06Z"
                    stroke="#07C07E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M51.36 60.5601L47.36 56.5601"
                    stroke="#07C07E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M47.36 60.5601L51.36 56.5601"
                    stroke="#07C07E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7045_265623">
                    <rect width="64" height="64" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_7045_265623">
                    <rect
                      width="62.45"
                      height="64.23"
                      fill="white"
                      transform="translate(1)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <h4 class="mt-6 text-center">{{ $t('message.emptyTable.theme.title') }}</h4>
            <p class="p-1 pt-4 text-center">
              {{ $t('message.emptyTable.theme.description') }}
            </p>
            <v-btn @click="addThemes = true" color="primary" large class="mt-8">
              <v-icon> $plus </v-icon>
              {{ $t('button.addNew') }}
            </v-btn>
          </div>
        </template>
      </template>

      <template v-slot:header="{ isMobile, props, on }" v-if="!itemsLoading">
        <table-custom-sort
          :isMobile="isMobile"
          :props="props"
          :v-on="on"
          :canBeSelected="canBeSelected"
          :allSelected="allSelected"
          @selectAll="handleSelectAll"
          v-on="$listeners"
        />
      </template>

      <template v-slot:item.select="{ item }">
        <div
          class="select-all item-bordered"
          :class="[item.status === 'active' ? 'item-bordered--green' : '']"
        >
          <checkbox
            @change="handleSelectItem(item)"
            :checked="checkedItems.includes(item.name)"
          />
        </div>
      </template>

      <template v-slot:item.title="{ item }">
        <div class="d-flex name-item">
          <v-avatar :size="64" elevation="0" class="mr-6" color="white">
            <v-img v-if="item.img" :src="item.img" />
          </v-avatar>
          <div class="d-flex flex-column">
            <span class="bold p-3">{{ item.title }}</span>
            <span class="p-4 item-desc base--text">
              {{ getDescription(item.description) }}
              <a
                @click="$emit('action-button-read-more', item)"
                class="truncate-text"
                v-if="item.description.length > 100"
              >
                <span class="base--text font-weight-regular">... </span>
                {{ $t('button.readMore') }}
              </a>
            </span>
          </div>
        </div>
      </template>

      <template v-slot:item.version="{ item }">
        <div class="d-flex align-center">
          <v-icon v-if="item.update !== 'available'" color="primary" size="16"
            >$alertok</v-icon
          >
          <v-icon v-else color="error" size="16">$alertwarning</v-icon>
          <span class="ml-2 font-weight-bold">{{ item.version }}</span>
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <status-label
          small
          :value="item.status == 'active' ? $t('message.status.activated') : $t('message.status.disabled')"
          :status="item.status == 'active' ? 'primary' : 'gray'"
        />
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex actions-row">
          <v-tooltip
            transition="custom-tooltip"
            open-delay="150"
            bottom
            z-index="99"
            offset-overflow
            nudge-bottom="4px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                v-if="item.status == 'inactive'"
                icon
                @click="$emit('action-button-activate', item)"
              >
                <v-icon>$checkcircle</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('tooltip.instance.theme.activate') }}</span>
          </v-tooltip>
          <v-tooltip
            transition="custom-tooltip"
            open-delay="150"
            bottom
            z-index="99"
            offset-overflow
            nudge-bottom="4px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <v-btn
                  small
                  icon
                  :disabled="item.update != 'available'"
                  @click="$emit('action-button-update', item)"
                >
                  <v-icon>$update</v-icon>
                </v-btn>
              </div>
            </template>
            <span>
              {{
                item.update != "available"
                  ? $t('tooltip.instance.theme.updated')
                  : $t('tooltip.instance.theme.update')
              }}
            </span>
          </v-tooltip>
          <v-tooltip
            transition="custom-tooltip"
            open-delay="150"
            bottom
            z-index="99"
            offset-overflow
            nudge-bottom="4px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                icon
                @click="$emit('action-button-delete', item)"
                ><v-icon>$thrash</v-icon></v-btn
              >
            </template>
            <span>{{ $t('tooltip.instance.theme.delete') }}</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:footer>
        <div>
          <data-iterator-footer
            :page="page"
            :numberOfPages="numberOfPages"
            :possibleItemsPerPage="possibleItemsPerPage"
            :listStyle="listStyle"
            :itemsPerPage="itemsPerPage"
            :itemsTotal="itemsTotal"
            v-on="$listeners"
            :perPageLabel="$t('table.footer.theme')"
          >
          </data-iterator-footer>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import DataIteratorMixin from "../../mixins/DataIteratorMixin";
import CustomTableMixin from "../../mixins/CustomTableMixin";

import DataIteratorFooter from "../dataIterator/DataIteratorFooter.vue";
import TableCustomSort from "../dataIterator/TableCustomSort.vue";
import Checkbox from "../buttons/Checkbox.vue";
import StatusLabel from "../StatusLabel.vue";
import DataIteratorNoResultsContainer from "../dataIterator/DataIteratorNoResultsContainer.vue";

import ThemeTableSortSkeleton from "./ThemeTableSortSkeleton.vue";
import ThemeTableSkeletonItem from "./ThemeTableSkeletonItem.vue";

export default {
  components: {
    DataIteratorFooter,
    TableCustomSort,
    Checkbox,
    StatusLabel,
    DataIteratorNoResultsContainer,
    ThemeTableSkeletonItem,
    ThemeTableSortSkeleton,
  },
  data: function () {
    return {
      canBeSelected: true,
    };
  },
  mixins: [DataIteratorMixin, CustomTableMixin],
  props: {
    headers: Array,
    itemsTotal: Number,
    itemsLoading: Boolean,
  },
  methods: {
    getPluginUrl: function (item) {
      return item.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
    },
    getDescription(item) {
      let currentLength = 120;

      for (let i = currentLength; i > 0; i--) {
        if (item.charAt(i - 1) === " ") {
          let result = item.slice(0, i - 1);
          return result + " ";
        }
      }
    },
    clearFilters: function () {
      this.searchTerm = "";
      this.filterLabels = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.item-desc {
  max-width: 412px;
  max-height: 36px;
  display: block;
  overflow: hidden;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

.name-item {
  width: 535px;
}

.v-btn {
  margin-left: 10px;
}

.v-data-table::v-deep {
  table tbody tr td {
    max-height: 84px;
    height: 84px !important;
    min-height: 84px;
  }
  table tbody tr {
    td:nth-child(2) {
      width: 535px;
    }
  }
}

.item-bordered {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: -24px;
    top: -19px;
    height: calc(100% + 37px);
    width: 4px;
    background-color: #dedef1;
  }

  &.item-bordered--red {
    &::after {
      background-color: #E71D1D !important;
    }
  }
  &.item-bordered--green {
    &::after {
      background-color: #07C07E !important;
    }
  }
}

.truncate-text {
  font-weight: $font-weight-bold;
  color: var(--v-info-base);
  display: inline;
  justify-content: flex-end;
  margin-left: -4px;
}

.v-avatar {
  border-color: var(--v-gray-lighten4) !important;
  border-style: solid !important;
  border-width: 1px !important;
}
.v-application--is-rtl{

.item-bordered::v-deep{
        &::after {
            right: -24px;
            left: unset;
        }
    }
}
</style>
